const fr = {
  // ─── Global ────────────────────────────────────────
  app_name: "Univers Libertin",
  app_tagline: "Votre espace safe, discret et bienveillant.",
  app_badge: "Adultes consentants · Communauté",
  loading: "Chargement...",
  save: "Sauvegarder",
  cancel: "Annuler",
  delete: "Supprimer",
  close: "fermer",
  send: "Envoyer",
  search: "Chercher",
  go: "Go",
  confirm_delete: "Supprimer ce post ?",
  no_results: "Aucun résultat trouvé.",
  error_generic: "Erreur interne.",
  footer_trust: "Confidentialité totale · Modération IA · Aucune donnée revendue",

  // ─── Nav ───────────────────────────────────────────
  nav_feed: "Fil",
  nav_directory: "Annuaire",
  nav_encounters: "Rencontres",
  nav_places: "Lieux",
  nav_messages: "Messages",
  nav_premium: "Premium",
  nav_profile: "Profil",
  nav_blog: "Blog",
  nav_logout: "Déconnexion",

  // ─── Age Gate ──────────────────────────────────────
  age_gate_title: "Espace réservé aux adultes",
  age_gate_desc: "Univers Libertin est une plateforme communautaire pour adultes consentants. L'accès est strictement réservé aux personnes majeures (18 ans et plus).",
  age_gate_confirm: "Je certifie avoir 18 ans ou plus — Entrer",
  age_gate_deny: "Je suis mineur·e — Quitter",

  // ─── Charter ───────────────────────────────────────
  charter_title: "Charte de consentement",
  charter_desc: "Engagez-vous à respecter ces principes fondamentaux pour accéder à la communauté.",
  charter_accept_all: "J'accepte la charte — Continuer",
  charter_accept_pending: "Acceptez les 3 engagements",
  charter_rule_consent_title: "Consentement absolu",
  charter_rule_consent_desc: "J'affirme être majeur·e (+18 ans). Je m'engage à respecter le consentement de chacun·e en toute circonstance. Un « non » ou un silence n'est jamais un « oui ». Aucune pression, insistance ou manipulation ne sera tolérée.",
  charter_rule_discretion_title: "Confidentialité totale",
  charter_rule_discretion_desc: "Ce qui se passe sur Univers Libertin reste sur Univers Libertin. Je ne partagerai jamais l'identité, les photos, les informations ou les activités d'un·e autre membre sans son accord explicite. Aucun outing.",
  charter_rule_respect_title: "Respect & Bienveillance",
  charter_rule_respect_desc: "Je respecte les limites, les pratiques et les choix de chacun·e sans jugement. Aucun body-shaming, slut-shaming, kink-shaming, ni discrimination d'aucune sorte. Chaque personne est libre de ses envies et de ses limites.",
  charter_read_again: "← Relire la charte",

  // ─── Auth ──────────────────────────────────────────
  auth_login: "Connexion",
  auth_signup: "Inscription",
  auth_pseudo: "Pseudo",
  auth_pseudo_placeholder: "Votre pseudo discret",
  auth_pseudo_hint: "Choisissez un pseudo — jamais votre vrai nom.",
  auth_email: "Email",
  auth_email_placeholder: "votre@email.com",
  auth_password: "Mot de passe",
  auth_password_placeholder: "Minimum 8 caractères",
  auth_login_btn: "Se connecter",
  auth_signup_btn: "Rejoindre la communauté",
  auth_logging_in: "Connexion...",
  auth_signing_up: "Création...",
  auth_signup_success: "Compte créé ! Connectez-vous maintenant.",

  // ─── Feed ──────────────────────────────────────────
  feed_placeholder: "Comment vous sentez-vous ? Partagez en toute sécurité...",
  feed_publish: "Publier",
  feed_analyzing: "Analyse...",
  feed_char_count: "{count}/2000 — Modéré par IA",
  feed_empty: "Aucun post pour le moment. Soyez le·la premier·e à partager.",
  feed_moderation_warning: "Votre message n'est pas conforme à notre charte de bienveillance.",

  // ─── Moods ─────────────────────────────────────────
  mood_neutral: "Neutre",
  mood_happy: "Heureux·se",
  mood_sad: "Triste",
  mood_anxious: "Anxieux·se",
  mood_grateful: "Reconnaissant·e",
  mood_angry: "En colère",
  mood_hopeful: "Plein·e d'espoir",

  // ─── Directory ─────────────────────────────────────
  directory_title: "Annuaire",
  directory_desc: "Explorez la communauté en toute discrétion.",
  directory_search_placeholder: "Chercher par ville...",
  directory_filter_all: "Tous",
  directory_no_profiles: "Aucun profil trouvé.",
  directory_send_message: "Envoyer un message →",
  directory_looking_for: "Recherche :",
  directory_interests: "Intérêts :",

  // ─── Filters ───────────────────────────────────────
  filter_gender: "Genre",
  filter_orientation: "Orientation",
  filter_status: "Situation",
  filter_all_genders: "Tous",
  filter_all_orientations: "Toutes",
  filter_all_statuses: "Tous",

  // ─── Gender ────────────────────────────────────────
  gender_unset: "Non précisé",
  gender_man: "Homme",
  gender_woman: "Femme",
  gender_nb: "Non-binaire",
  gender_other: "Autre",

  // ─── Orientation ───────────────────────────────────
  orientation_unset: "Non précisé",
  orientation_hetero: "Hétéro",
  orientation_bi: "Bi",
  orientation_gay: "Gay",
  orientation_lesbian: "Lesbienne",
  orientation_pan: "Pan",
  orientation_curious: "Curieux·se",
  orientation_other: "Autre",

  // ─── Relationship ──────────────────────────────────
  status_unset: "Non précisé",
  status_solo: "Solo",
  status_couple: "En couple",
  status_open: "Couple ouvert",
  status_poly: "Polyamoureux·se",
  status_other: "Autre",

  // ─── Experience ────────────────────────────────────
  level_unset: "Non précisé",
  level_curious: "Curieux·se",
  level_beginner: "Débutant·e",
  level_experienced: "Expérimenté·e",
  level_confirmed: "Confirmé·e",

  // ─── Profile ───────────────────────────────────────
  profile_title: "Mon profil",
  profile_desc: "Personnalisez votre présence. Seul votre pseudo est visible, jamais votre email.",
  profile_avatar: "Avatar",
  profile_photos: "Photos de profil",
  profile_photos_hint: "Vous pouvez flouter certaines photos. Passez Premium pour en uploader davantage.",
  profile_identity: "Identité",
  profile_display_name: "Nom affiché",
  profile_display_name_placeholder: "Pseudo ou surnom",
  profile_bio: "Bio",
  profile_bio_placeholder: "Décrivez-vous, vos envies, ce qui vous attire...",
  profile_city: "Ville",
  profile_city_placeholder: "Votre ville",
  profile_age: "Âge",
  profile_experience: "Expérience",
  profile_department: "Département",
  profile_department_unset: "Non précisé",
  profile_region: "Région",
  profile_region_unset: "Non précisé",
  profile_looking_for: "Je recherche",
  profile_interests: "Centres d'intérêt",
  profile_interests_add: "Ajouter...",
  profile_boundaries: "Mes limites & safe words",
  profile_boundaries_placeholder: "Ce que vous ne souhaitez pas, vos limites claires, votre safe word...",
  profile_boundaries_hint: "Vos limites sont visibles par les autres membres. Elles seront respectées.",
  profile_privacy: "Confidentialité",
  profile_visible: "Visible dans l'annuaire",
  profile_visible_desc: "Désactivez pour masquer votre profil.",
  profile_show_age: "Afficher mon âge",
  profile_show_age_desc: "Votre âge sera visible sur votre profil.",
  profile_allow_messages: "Accepter les messages privés",
  profile_allow_messages_desc: "Autorisez les autres membres à vous écrire.",
  profile_save: "Sauvegarder mon profil",
  profile_saving: "Sauvegarde...",
  profile_saved: "Profil sauvegardé !",

  // ─── Looking for options ───────────────────────────
  looking_discussions: "Discussions",
  looking_friendship: "Amitié libertine",
  looking_soft: "Rencontres soft",
  looking_parties: "Soirées privées",
  looking_couple: "Plan couple",
  looking_solo: "Plan solo",
  looking_swinging: "Échangisme",
  looking_melangisme: "Mélangisme",
  looking_voyeur: "Voyeurisme/Exhib",
  looking_bdsm: "BDSM",
  looking_poly: "Polyamour",
  looking_clubs: "Sorties clubs",

  // ─── Encounters ────────────────────────────────────
  encounters_title: "Rencontres",
  encounters_desc: "Proposez ou rejoignez des événements.",
  encounters_propose: "+ Proposer",
  encounters_new: "Nouvelle proposition",
  encounters_title_placeholder: "Titre (ex: Soirée libertine soft à Paris)",
  encounters_desc_placeholder: "Décrivez l'événement, l'ambiance, vos attentes...",
  encounters_category: "Catégorie",
  encounters_who: "Qui peut rejoindre",
  encounters_city: "Ville",
  encounters_date: "Date & heure",
  encounters_max: "Max participants",
  encounters_location: "Lieu (nom du club, adresse, lien...)",
  encounters_dresscode: "Dress code (optionnel)",
  encounters_online: "En ligne",
  encounters_rules: "Règles de l'événement (optionnel)",
  encounters_publish: "Publier la proposition",
  encounters_creating: "Création...",
  encounters_created: "Proposition créée !",
  encounters_join: "Rejoindre →",
  encounters_join_placeholder: "Présentez-vous brièvement...",
  encounters_request_sent: "Demande envoyée !",
  encounters_empty: "Aucune rencontre pour le moment.",
  encounters_open: "Ouvert",
  encounters_full: "Complet",
  encounters_places: "{count}/{max} places",
  encounters_by: "par {name} · {date}",
  encounters_date_flexible: "Date flexible",

  // ─── Encounter categories ──────────────────────────
  cat_all: "Toutes",
  cat_soiree: "Soirée privée",
  cat_club: "Club",
  cat_meetup: "Rencontre",
  cat_afterwork: "Afterwork",
  cat_sauna: "Sauna / Spa",
  cat_voyage: "Voyage",
  cat_weekend: "Weekend",
  cat_online: "En ligne",
  cat_couple_seek: "Recherche couple",
  cat_soft: "Soft / Découverte",
  cat_discussion: "Discussion",
  cat_other: "Autre",

  // ─── Who can join ──────────────────────────────────
  who_all: "Ouvert à tou·te·s",
  who_couples: "Couples uniquement",
  who_men: "Hommes uniquement",
  who_women: "Femmes uniquement",
  who_couples_women: "Couples & femmes",
  who_verified: "Profils vérifiés",

  // ─── Places ────────────────────────────────────────
  places_title: "Lieux",
  places_desc: "L'annuaire des lieux libertins recommandés par la communauté.",
  places_add: "+ Ajouter",
  places_suggest: "Suggérer un lieu",
  places_name: "Nom du lieu",
  places_name_desc: "Décrivez le lieu, l'ambiance, ce qui le rend spécial...",
  places_category: "Catégorie",
  places_city: "Ville",
  places_department: "Département",
  places_department_select: "Sélectionner...",
  places_region: "Région",
  places_region_auto: "Auto (depuis département)",
  places_region_all: "Toute la France",
  places_price: "Tarif",
  places_address: "Adresse complète (optionnel)",
  places_website: "Site web (optionnel)",
  places_features: "Équipements & caractéristiques",
  places_submit: "Soumettre",
  places_submitting: "Envoi...",
  places_submitted: "Lieu soumis !",
  places_empty: "Aucun lieu trouvé.",
  places_reviews: "avis",
  places_review_cta: "Donner mon avis →",
  places_review_general: "Général",
  places_review_ambiance: "Ambiance",
  places_review_respect: "Respect",
  places_review_hygiene: "Hygiène",
  places_review_placeholder: "Votre retour d'expérience...",
  places_review_publish: "Publier",
  places_review_published: "Avis publié !",
  places_verified: "✓ Vérifié",
  places_search_placeholder: "Chercher par ville...",

  // ─── Place categories ─────────────────────────────
  pcat_all: "Tous",
  pcat_club: "Club libertin",
  pcat_sauna: "Sauna / Spa",
  pcat_bar: "Bar",
  pcat_hotel: "Hôtel",
  pcat_beach: "Plage / Nature",
  pcat_camping: "Camping",
  pcat_restaurant: "Restaurant",
  pcat_association: "Association",
  pcat_boutique: "Boutique",
  pcat_online: "En ligne",
  pcat_other: "Autre",

  // ─── Price ─────────────────────────────────────────
  price_unset: "Non précisé",
  price_free: "Gratuit",
  price_low: "€ (< 30€)",
  price_mid: "€€ (30-80€)",
  price_high: "€€€ (> 80€)",

  // ─── Messages ──────────────────────────────────────
  messages_title: "Messages",
  messages_desc: "Vos conversations privées et discrètes.",
  messages_empty: "Aucune conversation pour le moment.",
  messages_go_directory: "Aller à l'annuaire →",
  messages_conversation: "Conversation",
  messages_start: "Début de la conversation. Soyez respectueux·se et bienveillant·e.",
  messages_placeholder: "Votre message...",
  messages_not_allowed: "Ce membre n'accepte pas les messages privés.",
  messages_moderation: "Message non conforme à la charte.",

  // ─── Premium ───────────────────────────────────────
  premium_title: "Passez Premium",
  premium_desc: "Débloquez toutes les fonctionnalités pour une expérience complète.",
  premium_current: "Actuel",
  premium_choose: "Choisir {name}",
  premium_manage: "Gérer l'abonnement",
  premium_redirecting: "Redirection...",
  premium_success: "Bienvenue dans le plan {plan} ! Profitez de toutes vos nouvelles fonctionnalités.",
  premium_footer: "Paiement sécurisé par Stripe · Annulation à tout moment · Sans engagement",
  premium_active_until: "Votre abonnement {name} est actif jusqu'au {date}.",
  plan_free: "Gratuit",
  plan_premium: "Premium",
  plan_vip: "VIP",
  plan_month: "/mois",

  // ─── Photos ────────────────────────────────────────
  photos_drop: "Cliquez ou glissez une image (JPG, PNG, WebP · max 5 Mo)",
  photos_count: "{current}/{max} photos",
  photos_uploading: "Upload en cours...",
  photos_limit: "Limite de {max} photos atteinte (plan {plan}).",
  photos_confirm_delete: "Supprimer cette photo ?",

  // ─── Visitors ──────────────────────────────────────
  visitors_title: "Qui a visité mon profil",
  visitors_count: "visites récentes",
  visitors_upsell: "Passez Premium pour découvrir qui s'intéresse à vous.",
  visitors_none: "Aucune visite récente.",

  // ─── Pro ───────────────────────────────────────────
  nav_pro: "Pro",
  nav_visitors: "Visiteurs",
  pro_title: "Dashboard Pro",
  pro_desc: "Gérez vos établissements revendiqués.",
  pro_claim: "C'est mon établissement",
  pro_no_places: "Aucun établissement revendiqué.",
  pro_pending: "Demandes en attente",

  // ─── Spotlight ─────────────────────────────────────
  spotlight_label: "Spotlight",
  spotlight_buy: "⭐ Boost 24h — 2.99€",
  spotlight_active: "Mis en avant",

};

export default fr;
